/**
 * @description
 *
 * 广告位数据采集功能，抽象公共方法，防止出现对象参数
 * 移动端数据收集和pc收集不太一样，建议统一
 */
import sdkTool from "If_AdTool/common/sdkTool";
import SendUrls from "If_AdTool/common/sendUrl";
let aptracker = (function () {
    //统计地址
    var URLArr = ['https://stadig.ifeng.com/apstat.js?',"https://stadig.ifeng.com/apwsta.js?"];
    //广告位ID集合
    var apids = [];
    var VERSION = '3.3.15';
    var T;
    /**
     * 构造参数
     */
    function buildQuery() {
        return sdkTool.isMobile()?mobileBuildQuery():pcBuildQuery()
    }
    //pc端数据收集
    function pcBuildQuery(){
        var queryString = '', province = '', city = '', userId = '';
        try {
            province = sdkTool.cookie('prov');
            city = sdkTool.cookie('city');
            userId = sdkTool.cookie('userid');
        } catch (e) {

        }
        // console.log(province,city,userId)
        queryString += 'url=' + encodeURIComponent(document.URL); // 当前页面的地址
        queryString += '&ap=' + apids.join('|'); // 广告位的ID集合
        queryString += '&ar=' + province; // 地域信息 目前只取到省
        queryString += '&cu=' + userId; // 用户的UID
        if (typeof window['getChannelInfo'] === 'function') {
            queryString += '&ci=' + encodeURIComponent(window['getChannelInfo']());
        }
        queryString += '&version=' + VERSION;
        return queryString;
    }
    //移动端数据收集
    function mobileBuildQuery(){
        var a = [];
        a.push("datatype=wapap");
        a.push("url=" + encodeURIComponent(window.location.href.replace(/&/g, "|")));
        a.push("ar="+sdkTool.cookie('city')||"");
        a.push("ap=" + apids.join('|'));
        a.push("cu=" + sdkTool.cookie('userid'))
        a.push("tm=" + (new Date).getTime());
        a.push("sys=" +sdkTool.getOs());
        a.push("browser=" + sdkTool.getBrowser());
        a.push("wh=" + getViewWH());
        return a.join("&")
    }
    function getViewWH() {
        return window.screen.width + "*" + window.screen.height
    }
    function getUrl(){
        return sdkTool.isMobile() ? URLArr[1] : URLArr[0]
    }
    var aptracker = {
        loadCmp:true,//页面是否加载完毕，
        delaySendTime:500,//延时发送时间
        add: function (apid) {
            apids.push(apid);
            if(this.loadCmp){
                    clearTimeout(T);
                    T = setTimeout(function(){
                        var queryString = buildQuery();
                        SendUrls([getUrl() + queryString])
                        apids.length =0;
                    },
                    this.delaySendTime);
            }
            return this;
        },
        get: function () {
            return getUrl() + buildQuery();
        },
        collection: function () {
            if (apids.length === 0||this.loadCmp) {
                return false;
            }
            var queryString = buildQuery();
            SendUrls([getUrl() + queryString])
            apids =[];
            this.loadCmp = true;
        }
    };
    return aptracker;
})();
export default aptracker;